import { faCertificate } from '@fortawesome/pro-duotone-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Typography } from '@mui/material'
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import { Col, Container, Row } from 'reactstrap'
// import JobAnnouncementTable from './Components/JobAnnouncement/JobAnnouncementTable' // --- REMOVED
// import EligibilityTable from './Components/Eligibility/EligibilityTable'
// import CustomizerContext from '../../_helper/Customizer'
// import ApplicantsTable from './Components/Applicants/ApplicantsTable'
// import FloatingTab from './Components/FloatingTab/FloatingTab' // --- REMOVED
// import StepperComponent from './Components/StepperComponent/StepperComponent' // This now acts as the "sub-stepper"
// import BadgesComponent from './Components/StepperComponent/BadgesComponent'
import { useLocation } from 'react-router-dom'
import StepperComponent from '../../Components/StepperComponent/StepperComponent'
import BadgesComponent from '../../Components/StepperComponent/BadgesComponent'
import ApplicantsTable from '../../Components/Applicants/ApplicantsTable'
import CustomizerContext from '../../../../_helper/Customizer'
import EligibilityTable from '../../Components/Eligibility/EligibilityTable'

// You might want to rename this component (e.g., EligibilityAndApplicants)
const SubSteps11 = ({ annId, setSubstepes }) => {
    // We still get data from context
    const { EligibilityTableShow, ApplicantTableShow, resetGenrateGeneralAvailability, setEligibilityTableShow } = useContext(CustomizerContext);

    // --- Refs ---
    // const announcementRef = useRef(null); // --- REMOVED
    const eligibilityRef = useRef(null);
    const applicantsRef = useRef(null);
    // const [refsReady, setRefsReady] = useState(false); // --- REMOVED (related to floating tab)

    // --- Location / State ---
    const location = useLocation();
    const { state } = location;
    // We still check for `notifyMore` to get the title and AnnouncementID
    const notifyCheck = useMemo(() => state?.notifyMore ? "true" : "", [state])

    // --- Step State ---
    // The component now only has 2 steps: 0 (Eligibility) and 1 (Applicants)
    // We default to step 0 (Eligibility)
    const [currentStep, setCurrentStep] = useState(0);

    // --- Effects ---

    // This effect is still needed to load the *initial* data for the Eligibility table
    // It uses the AnnouncementID passed in the location state
    useEffect(() => {
        if (state?.notifyMore) {
            // We set the *data* for the Eligibility table
            // We are already on step 0, so no need to call setCurrentStep
            setTimeout(() => setEligibilityTableShow(
                {
                    "ANNOUNCEMENT_ID": annId
                }
            ), 200)

        } else {
            // You need to handle the "Generate General Availability" flow
            // Since JobAnnouncementTable is gone, you MUST pass the
            // ANNOUNCEMENT_ID in the location state for that flow as well.
            // For example, if state.AnnouncementID is passed *without* notifyMore:
            if (annId) {
                setTimeout(() => setEligibilityTableShow(
                    {
                        "ANNOUNCEMENT_ID": annId
                    }
                ), 200)
            }
        }
    }, [notifyCheck, annId]) // Added state.AnnouncementID dependency


    // This effect is no longer needed as it was for the FloatingTab
    // useEffect(() => {
    //     setRefsReady(false)
    //     setTimeout(() => {
    //         if (eligibilityRef.current || applicantsRef.current) {
    //             setRefsReady(true);
    //         }
    //     }, 0)
    // }, [EligibilityTableShow, ApplicantTableShow]);


    // This cleanup effect is still valid
    useEffect(() => {
        return () => {
            // We only reset if we are NOT in the "notifyMore" flow,
            // assuming "Generate GA" is a self-contained flow.
            if (!state?.notifyMore)
                resetGenrateGeneralAvailability()
        }
    }, [])

    // This logic to get the ID for the BadgesComponent is still valid
    const ANNOUNCEMENT_ID_Value = useMemo(() => {
        const { ANNOUNCEMENT_ID } = EligibilityTableShow
        if (ANNOUNCEMENT_ID) return ANNOUNCEMENT_ID.trim()
        return ""
    }, [EligibilityTableShow])


    return (
        // The Container and Row for the *title* are part of the main page
        // This component should be wrapped in <Container> <Row> <Col> by its parent
        <>
            {/* The parent page handles the main "Step 1" title. */}
            {/* This component provides the *sub-steps* */}

            <Row>
                <Col>
                    {/* This StepperComponent now shows the *sub-steps*.
                      You will need to configure it to show 2 steps 
                      (e.g., "Eligibility", "Applicants") instead of 3.
                    */}
                    <StepperComponent
                        currentStep={currentStep}
                        setCurrentStep={setCurrentStep}
                        removeAnnList={true}
                    // You may need to pass new props, e.g., steps={['Eligibility', 'Applicants']}
                    />

                    {annId && (
                        <div style={{ marginTop: "15px", marginBottom: "15px" }}>
                            <BadgesComponent />
                        </div>
                    )}

                    {/* --- STEP 0: ELIGIBILITY (Was Step 1) --- */}
                    {/* We check `EligibilityTableShow` which is set by the useEffect above.
                      This ensures the table doesn't render before its data is ready. 
                    */}
                    {annId && currentStep == 0 && (
                        <div id="eligibility-section" ref={eligibilityRef}>
                            {/* EligibilityTable must call setCurrentStep(1) to move to Applicants */}
                            <EligibilityTable setCurrentStep={setCurrentStep} annId={annId} />
                        </div>
                    )}

                    {/* --- STEP 1: APPLICANTS (Was Step 2) --- */}
                    {/* This logic remains the same. `EligibilityTable` will set 
                      `ApplicantTableShow` in context to enable this step.
                    */}
                    {ApplicantTableShow && currentStep == 1 && (
                        <div id="applicants-section" ref={applicantsRef}>
                            <ApplicantsTable setSubstepes={setSubstepes} />
                        </div>
                    )}

                    {/* --- Floating tab is removed --- */}
                    {/* {refsReady && ( ... )} */}
                </Col>
            </Row>
        </>
    );
}

export default SubSteps11